export default __webpack_public_path__ + "static/media/type1_4in.67baffe8.svg";